export default __webpack_public_path__ + "static/media/room_1.920f00a1.png";